import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { HeartHandshake } from "lucide-react";
import TransferDetails from "./TransferDetails";

// Modal global de pago por transferencia. Se abre con:
//   window.dispatchEvent(new CustomEvent("clinped-open-transfer", { detail: { plan } }))
// o con openTransfer(plan) de lib/transfer.
export default function TransferModal() {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState("pro");

  useEffect(() => {
    const onOpen = (e) => { setPlan(e.detail?.plan || "pro"); setOpen(true); };
    window.addEventListener("clinped-open-transfer", onOpen);
    return () => window.removeEventListener("clinped-open-transfer", onOpen);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="rounded-3xl max-w-md max-h-[90vh] overflow-y-auto" data-testid="transfer-modal">
        <DialogHeader>
          <div className="w-12 h-12 rounded-2xl bg-brand-sage/15 flex items-center justify-center mb-1">
            <HeartHandshake size={24} className="text-brand-sageDark" />
          </div>
          <DialogTitle className="font-outfit text-xl text-brand-ink">No se procesó tu pago, pero no te preocupes</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed">
            Puedes pagar por transferencia bancaria y seguir disfrutando de <b>ClinPed</b>, tu expediente electrónico inteligente. Es rápido y seguro.
          </DialogDescription>
        </DialogHeader>
        <TransferDetails plan={plan} />
      </DialogContent>
    </Dialog>
  );
}
